import { render, staticRenderFns } from "./TaBetweenText.vue?vue&type=template&id=a0ceaa00&scoped=true&"
import script from "./TaBetweenText.vue?vue&type=script&lang=js&"
export * from "./TaBetweenText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ceaa00",
  null
  
)

export default component.exports